import React, { FC, useEffect, useMemo, useState } from "react";
import { useEndpoints } from "../../hooks/useEndpoints";
import { useLocation } from "react-router-dom";
import { useSimpleForm } from "../../hooks/useSimpleForm";
import CustomCard from "../../shared/Card/CustomCard";
import Typhography from "../../shared/Typhography/Typhography";
import CustomPasswordInput from "../../shared/CustomPasswordInput/CustomPasswordInput";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { useToastAlert } from "../../hooks/useToastAlert/useToastAlert";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { useMe } from "../../hooks/useMe";
import HeaderLogin from "../../shared/HeaderLogin/HeaderLogin";
import FooterLogin from "../../shared/FooterLogin/FooterLogin";
import "./ConfirmUserGym.scss";
import LoadingPage from "../../shared/LoadingPage/LoadingPage";
import { AxiosError, isAxiosError } from "axios";

interface IConfirmUserGym {}

const valuesTypography = {
  true: {
    title: "Congratulazioni",
    description: "Accedi al tuo account per accedere alla nuova palestra",
  },
  false: {
    title: "Ops! Qualcosa è andato storto",
    description: "Chiedi alla tua palestra di ripetere la procedura.",
  },
  undefined: {
    title: "Caricamento",
    description: "Attendi solo qualche instante",
  },
  alreadyConfirmed: {
    title: "Sei già autenticato",
    description: "Il tuo account è già autenticato",
  },
};

const ConfirmUserGym: FC<IConfirmUserGym> = () => {
  const location = useLocation();
  const { resetMe } = useMe();
  const { confirmUserGym } = useEndpoints();
  const toastAlert = useToastAlert();
  const { navigate } = useCustomNavigate();
  const [typography, setTypography] = useState(valuesTypography.undefined);
  const [status, setStatus] =
    useState<keyof typeof valuesTypography>("undefined");
  useEffect(() => {
    (async () => {
      try {
        const query = new URLSearchParams(location.search);
        const token = query.get("confirmToken");
        if (!token) {
          return;
        }
        await handleConfirmUserGym(token);
      } catch (error) {
        console.error("error", error);
      }
    })();
    // eslint-disable-next-line
  }, [location.search]);

  const handleConfirmUserGym = async (token: string) => {
    setStatus("undefined");
    try {
      resetMe();
      await confirmUserGym({ token });
      setStatus("true");
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response?.data.error[0] === "User gym already confirmed") {
          setStatus("alreadyConfirmed");
        }
      } else {
        setStatus("false");
      }
      console.error("error", error);
    } finally {
    }
  };

  useEffect(() => {
    setTypography(valuesTypography[status]);
  }, [status]);

  return (
    <div className="container__login">
      <div className="container__header">
        <HeaderLogin />
        <div id="container-form" className="container__form">
          <Typhography className="pb-3" size="bold-24">
            {typography.title}
          </Typhography>
          <Typhography className="pb-32" size="regular-16">
            {typography.description}
          </Typhography>

          {status === undefined && <LoadingPage />}
          {status !== undefined && (
            <CustomButton
              fullWidth
              onClick={() => {
                navigate("GYM_LOGIN");
              }}
            >
              LOGIN
            </CustomButton>
          )}
        </div>
      </div>
      <div className="container__footer">
        <FooterLogin />
      </div>
    </div>
  );
};

export default ConfirmUserGym;
